// extracted by mini-css-extract-plugin
export default {"footerBg":"bb-z","footerTopLinks":"cb-z","footerFeedback":"db-z","footerSocial":"eb-z","footerLegalLinks":"fb-z","footerIconCards":"gb-z","footerBotCopy":"hb-z"};